var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        destroyOnClose: true,
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules }
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["parentNode"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "pid"
                  }
                },
                [
                  _c("j-category-select-prevent", {
                    ref: "treeSelect",
                    attrs: { currid: _vm.currid },
                    model: {
                      value: _vm.model.pid,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "pid", $$v)
                      },
                      expression: "model.pid"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["categoryName"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "name"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["categoryName"]
                    },
                    model: {
                      value: _vm.model.name,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "name", $$v)
                      },
                      expression: "model.name"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }